export const quotes = [
  {
    title: "Healing Is a Journey",
    text: "You help patients move forward — one step, one choice, one moment at a time."
  },
  {
    title: "Every Step Matters",
    text: "Progress isn't always fast — but with your guidance, it's always forward."
  },
  {
    title: "You Walk With Them",
    text: "Patients don't walk this path alone — you're beside them, every mile."
  },
  {
    title: "From Plan to Progress",
    text: "Your coordination turns clinical plans into real-world healing."
  },
  {
    title: "Guided with Purpose",
    text: "You connect the dots — between care, clarity, and confidence."
  },
  {
    title: "A Steady Presence",
    text: "Healing can feel uncertain. Your calm is a form of care."
  },
  {
    title: "Hope, Made Practical",
    text: "You turn hope into action by helping patients navigate each decision."
  },
  {
    title: "Healing Is Personal",
    text: "You treat patients as people — not problems — and that's where healing begins."
  },
  {
    title: "Progress You Can't Always See",
    text: "Behind every scheduled call and follow-up is a life getting stronger."
  },
  {
    title: "You Build Momentum",
    text: "Healing isn't linear — but your support helps keep it moving."
  },
  {
    title: "Care Beyond the Clinic",
    text: "You extend care into real life — where healing actually happens."
  },
  {
    title: "Patients Deserve a Guide",
    text: "You offer direction when the path is unclear — and that makes all the difference."
  },
  {
    title: "Clarity as Care",
    text: "Information is healing. You give patients the clarity they need to act."
  },
  {
    title: "Turning Insight Into Action",
    text: "You translate care plans into steps patients can take today."
  },
  {
    title: "Your Work Changes Outcomes",
    text: "Because of you, healing isn't left to chance — it becomes possible, and personal."
  }
];
